import { isDefined } from "@clipboard-health/util-ts";
import type { UseModalState } from "@src/appV2/redesign/system/ui-components";
import { SHIFT_DETAILS_UPDATE_ETA_FULL_PATH } from "@src/appV2/redesign/WorkerShifts/path";
import { parseISO } from "date-fns";
import { generatePath, useHistory, useLocation } from "react-router-dom";

import { UPDATE_ETA_BOTTOM_SHEET_SOURCE } from "../types";
import { UpdateEtaConfirmedBottomSheet } from "./BottomSheet";

interface UpdateEtaConfirmedBottomSheetContainerProps {
  modalState: UseModalState;
  shiftId: string;
}

interface UpdateEtaConfirmedHistoryState {
  updatedEta?: string;
  workplaceTimezone?: string;
}

export function UpdateEtaConfirmedBottomSheetContainer(
  props: UpdateEtaConfirmedBottomSheetContainerProps
) {
  const { modalState, shiftId } = props;
  const history = useHistory();
  const location = useLocation<UpdateEtaConfirmedHistoryState>();
  const { updatedEta: updatedEtaIso, workplaceTimezone } = location.state ?? {};
  const updatedEta = isDefined(updatedEtaIso) ? parseISO(updatedEtaIso) : undefined;

  return (
    <UpdateEtaConfirmedBottomSheet
      modalState={modalState}
      updatedEta={updatedEta}
      workplaceTimezone={workplaceTimezone}
      onEditMyEta={() => {
        history.replace(
          generatePath(
            `${SHIFT_DETAILS_UPDATE_ETA_FULL_PATH}?source=${UPDATE_ETA_BOTTOM_SHEET_SOURCE.EDIT_ETA_AFTER_CONFIRMATION}`,
            { shiftId }
          )
        );
      }}
    />
  );
}
